import { RefObject, useCallback } from "react";

import useStickyRow from "ds/components/Table/hooks/useStickyRow";
import TableSimpleRow from "ds/components/TableSimple/Row";
import { TableCellPerColumn } from "ds/components/TableSimple/types";
import { TableColumnMeta } from "ds/components/Table/types";

import { IntentResourceRow } from "./tableDataSelectors";

type IntentProjectResourcesTableStickyGroupRowProps = {
  row: IntentResourceRow;
  columns: TableColumnMeta[];
  isFirstColumnPinned: boolean;
  cellPerColumn: TableCellPerColumn<IntentResourceRow>;
  keyboardProps: Record<string, unknown>;
  measureRef: (node: HTMLDivElement | null) => void;
  dataIndex: number;
  isActiveSticky: boolean;
  nextAfterSticky?: number;
  tableRef: RefObject<HTMLDivElement | null>;
};

const IntentProjectResourcesTableStickyGroupRow = ({
  row,
  columns,
  isFirstColumnPinned,
  cellPerColumn,
  keyboardProps,
  measureRef,
  dataIndex,
  isActiveSticky,
  nextAfterSticky,
  tableRef,
}: IntentProjectResourcesTableStickyGroupRowProps) => {
  const rowRef = useStickyRow(isActiveSticky, nextAfterSticky, tableRef);

  const setRef = useCallback(
    (node: HTMLDivElement | null) => {
      measureRef(node);
      rowRef.current = node;
    },
    [measureRef, rowRef]
  );

  return (
    <TableSimpleRow
      itemId={row.resourceID}
      item={row}
      columns={columns}
      isFirstColumnPinned={isFirstColumnPinned}
      cellPerColumn={cellPerColumn}
      keyboardProps={keyboardProps}
      measureRef={setRef}
      dataIndex={dataIndex}
      isGroupOpen={isActiveSticky}
      virtualized
    />
  );
};

export default IntentProjectResourcesTableStickyGroupRow;
